import { useEffect } from "react";
import { loadLandingTrackingScripts } from "./utils/loadLandingTracking";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ThankYou from "./pages/ThankYou";

function App() {
  useEffect(() => {
    loadLandingTrackingScripts();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
